<template>
    <div>
        <Navbar />
    </div>
</template>

<script>
    import Navbar from './Navbar'
    
    export default {
        components: {
            Navbar
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Headers/Headers.vue